import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

import { ref, computed, onMounted, onUnmounted }    from 'vue';

/********************************
 ********** COMPONENTS **********
 *******************************/
import {Chart} from 'highcharts-vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useTheme } from 'vuetify';
import { getOptionsInGraphs } from '@/functions/project';

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTGRAPHS          from '@/constants/graphs';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompareCharts',
  props: {
    firstArray      : { required:true },
    secondArray     : { required:true },
    namePrimary     : { required:true },
    nameSecundary   : { required:true },
    colorFirst      : { required:true },
    colorSecond     : { required:true },
    title           : { required:true, type:String },
    subtitle        : { required:true, type:String },
    typeChart       : { required:true, type:String }
},
  setup(__props) {

const props = __props;

const theme = useTheme();

/********************************
 *********** FUNCTION ***********
 *******************************/



const potLine       = ref(CONSTGRAPHS.POTLINE[props.typeChart]);
const zones         = ref(CONSTGRAPHS.ZONES[props.typeChart]);
const colorText     = computed(() => theme.global.current.value.colors.colorText);
const yAxisTitle    = ref(CONSTGRAPHS.YAXISLABEL[props.typeChart] || '');

/* eslint-disable */

const finalSeries = ref( [
        {
            name: props.namePrimary,
            data: props.firstArray,
            color: props.colorFirst,
            zones: zones.value,
        },
        {
            name: props.nameSecundary,
            data: props.secondArray,
            color: props.colorSecond,
            zones: zones.value,
        }
])
const finalYAxis = ref({
        title: {
            text: yAxisTitle,
            style:{ color: colorText }
        },
        plotLines: [ {
            value: potLine,
            color: 'red',
            dashStyle: 'shortdash',
            width: 2,
            label: {
                text: props.typeChart == 'predict' ? '-75dBm' : '20dBm',
                style:{ color: colorText }
            }
        },
    ],
})

/**
 * getOptionsInGraphs(tipo, serie, titulo, subtitulo, ocultar leyenda, altura, tooltip, yaxis)
 */
const finalOptions:any = ref(getOptionsInGraphs('line',finalSeries.value,props.title, props.subtitle,false,550,{valueDecimals: 2},finalYAxis));

const chartRef = ref<any>();
const duplicateChart = ref();

const isactive = ref(false);

const onClickOutside = () => {
    isactive.value = false;
}

const activeClick = () =>{
    isactive.value = true;
}

onMounted(async () => {
    setTimeout(() => {
        duplicateChart.value = chartRef.value;
    }, 500);
});

onUnmounted(() => {
    if(duplicateChart.value){
        duplicateChart.value.chart.destroy();
    }
});

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock(_component_v_sheet, {
    color: "transparent",
    class: "containerAreaSheet",
    onClick: activeClick
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Chart), {
        constructorType: 'stockChart',
        class: _normalizeClass(["hc", isactive.value ? 'borderActive' : '']),
        options: finalOptions.value,
        ref_key: "chartRef",
        ref: chartRef
      }, null, 8, ["options", "class"]),
      (!isactive.value)
        ? (_openBlock(), _createBlock(_component_v_sheet, {
            key: 0,
            class: "areaChartSheet"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  })), [
    [_directive_click_outside, {handler: onClickOutside}]
  ])
}
}

})